import {
  IGetWebinarParentDataRes,
  IPaymentReq,
  ISubmitBookSessionReq,
  MockExamParent,
} from '@models/interfaces/mock_exam.interface';
import PUBLIC_API from '@services/public.service';
import { MOCK_EXAM_UID_KEY } from '@utils/constants/mock-exam.constants';
import Cookies from 'js-cookie';
import LOCAL_API from './local.service';

const MockExamService = {
  async registerParent(registrationData: MockExamParent) {
    const response = await PUBLIC_API.post(
      `/user/mock_exam_reg_parent/json`,
      registrationData,
    );

    return { response, registrationData };
  },
  async getScheduleList() {
    return await PUBLIC_API.post(
      `/summative_assessment/get_schedule_list/json`,
    );
  },
  async getStudentList() {
    PUBLIC_API.defaults.headers.uid = Cookies.get(MOCK_EXAM_UID_KEY) || null;
    return await PUBLIC_API.post(`/summative_assessment/get_student_list/json`);
  },
  async submitBookSession(submitData: ISubmitBookSessionReq) {
    PUBLIC_API.defaults.headers.uid = Cookies.get(MOCK_EXAM_UID_KEY) || null;
    return await PUBLIC_API.post(
      `/summative_assessment/book_session/json`,
      submitData,
    );
  },
  async getSchoolList() {
    return await PUBLIC_API.post(`/summative_assessment/school_list/json`);
  },

  visitTracker(isMockExam: boolean, step: string) {
    return PUBLIC_API.post(`/summative_assessment/visit_tracker/json`, {
      type: isMockExam ? 1 : 2,
      step: step,
    });
  },
  async getWebinarParentData(id: string | undefined) {
    return await PUBLIC_API.post<IGetWebinarParentDataRes>(
      `/webinar/get_webinar_data/json`,
      {
        url_code: id,
      },
    );
  },
  async requestPaymentLink(requestData: IPaymentReq) {
    return await LOCAL_API.post(`/payment_api/webinar_payment`, requestData);
  },
};

export default MockExamService;
